import $ from 'jquery';
import 'slick-carousel';
import isMobile from 'ismobilejs';
import {enableScroll, disableScroll} from '../page/page';
import {close, isCloseByClick, show} from '../notice/notice';

export default class {
	constructor() {
		this.selectors = {
			slider: '.js-slider-item',
			sliderFull: '.js-slider-full',
			toggle: '.js-full-toggle',
			close: '.js-slider-full-close',
			wrapper: '.js-item-top',
			previewImage: '.js-slider-preview-image',
			slickActive: '.slick-track'
		};

		this.classes = {
			fullView: 'item__top_state_full',
			noscroll: 'noscroll'
		};

		this.$slider = $(this.selectors.slider);
		this.$sliderFull = $(this.selectors.sliderFull);
		this.$toggle = $(this.selectors.toggle);
		this.$close = $(this.selectors.close);
		this.$wrapper = $(this.selectors.wrapper);

		this.navFor = this.$sliderFull.length ? '.js-slider-item-sync' : '.js-slider-preview';
		this.imageY = 0;

		this.$document = $(document);
		this.$body = $('body');
		this.clickPoint = 0;
	}

	slickInit() {
		this.$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			speed: 0,
			asNavFor: this.navFor,
			waitForAnimate: true,
			dotsClass: 'slider-item__dots',
			prevArrow: '<span class="slider-item__arrow slider-item__arrow_type_prev"><svg><use xlink:href="/assets/images/icon.svg#icon_arrow-left"></use></svg></span>',
			nextArrow: '<span class="slider-item__arrow slider-item__arrow_type_next"><svg><use xlink:href="/assets/images/icon.svg#icon_arrow-left"></use></svg></span>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						dots: true
					}
				}
			]
		});
		if (this.$sliderFull.length) {
			this.$sliderFull.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: false,
				draggable: false,
				fade: true,
				speed: 0,
				cssEase: 'linear',
				asNavFor: '.js-slider-preview',
				waitForAnimate: true
			});

			if (!isMobile.any) {
				this.$sliderFull.on('afterChange', () => {
					this.$sliderFull.find(this.selectors.slickActive).css('transform', `translate3d(0, ${this.imageY}px, 0)`);
				});
			}
		}
	}

	previewMousemove(e) {
		this.$previewImage = $(this.selectors.previewImage);
		let y = 0;
		if ( window.innerWidth < 1024 && this.clicked ) {
			y = this.clickPoint - e.clientY;
		} else {
			y = e.clientY;
		}
		const height = window.innerHeight;
		const percent = ( y / ( height / 100 ));
		const image = this.$sliderFull.find(this.selectors.slickActive);
		this.imageY = -(( Math.abs(image.find('img').height() - height + 400 ) / 100 ) * percent);

		if ( window.innerWidth < 1024 && this.clicked ) {
			this.imageY = this.clickTop + this.imageY;
		}
		if (( this.imageY > -( image.find('img').height() - ( window.innerHeight - 300 ) ) && (this.clickPoint - e.clientY) > 0) || ( this.imageY <= 0 && (this.clickPoint - e.clientY) < 0)) {
			image.css('transform', `translate3d(0, ${this.imageY}px, 0)`);
		}
	}

	openFullView(e) {
		close();
		this.$wrapper.addClass(this.classes.fullView);
		this.fullscreen = true;

		if (!isMobile.any) {
			this.previewMousemove(e);
		}

		disableScroll();
		this.scrollTop = $('body').scrollTop();
		$('body').scrollTop(0);
	}

	closeFullView() {
		this.$wrapper.removeClass(this.classes.fullView);
		this.fullscreen = false;
		enableScroll();
		$('body').scrollTop(this.scrollTop);

		if (!isCloseByClick()) {
			show();
		}
	}

	addMoseListeners() {
		this.$document.on('mousedown', e => {
			const $image = this.$sliderFull.find(this.selectors.slickActive);
			this.clicked = true;
			this.clickPoint = e.clientY;
			if ($image.length) {
				this.clickTop = $image.offset().top;
			}
		});

		$(window).on('mouseup', () => {
			this.clicked = false;
		});
		this.$document.on('mousemove', e => {
			if (this.fullscreen) {

				if ( window.innerWidth < 1024 && this.clicked ) {
					this.previewMousemove(e);
				} else if (window.innerWidth >= 1024 ) {
					this.previewMousemove(e);
				}

			}
		});
	}

	addScrolls() {
		this.$sliderFull.find(this.selectors.slickActive).css({
			overflow: `scroll`,
			transform: `translate3d(0, 0, 0)`
		});

		this.$sliderFull.css({
			overflow: `scroll`,
			height: `100%`
		});
	}

	render() {
		if (this.$slider.length) {
			this.slickInit();
			this.$toggle.on('click', e => this.openFullView(e));
			this.$close.on('click', () => this.closeFullView());
			this.$document.on('keydown', e => {
				if (e.keyCode === 27) {
					this.closeFullView();
				}
			});

			if (!isMobile.any) {
				this.addMoseListeners();
			} else {
				this.addScrolls();
			}
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/slider-item/slider-item.js
 **/